import { Controller } from "@hotwired/stimulus";
import { SlickGrid, SlickDataView } from "slickgrid";

import Sortable from "sortablejs";
window.Sortable = Sortable;

export default class extends Controller {
  static outlets = ["pages--market-data--market-modal"];

  connect() {
    try {
      const { columns, rows } = this.loadData();

      if (columns && rows) {
        this.renderTable(columns, rows);
      }
    } catch (error) {
      console.error('Market Table - Error initializing:', error);
    }
  }

  loadData() {
    const dataScript = document.getElementById('market-table-data');
    if (!dataScript) {
      console.error('Market Table - Data script tag not found');
      return {};
    }
    const data = JSON.parse(dataScript.textContent);
    return { columns: data.columns, rows: data.rows };
  }

  renderTable(columns, rows) {
    columns.forEach(column => {
      if (column.id === 'chart' || column.id === 'move' || column.id === 'name') {
        column.formatter = this.htmlFormatter;
      }
    });

    const dataView = new SlickDataView();
    dataView.getItemMetadata = (row) => this.getItemMetadata(dataView, row);
    dataView.setItems(rows);

    const gridElement = document.getElementById("market-data-slickgrid");
    if (!gridElement) {
      console.error('Market Table - Target element not found: market-data-slickgrid');
      return;
    }

    // Calculate grid height with minimum 10 rows and maximum viewport space
    const rowHeight = 32; // From grid options
    const rowHeaderHeight = 32; // From grid options
    const pageHeaderHeight = 220; // Approximate page header height for market data

    // Minimum height: 10 rows
    const minHeight = (10 * rowHeight) + rowHeaderHeight;

    // Maximum height: estimated remaining viewport space
    const viewportHeight = window.innerHeight;
    const maxHeight = viewportHeight - pageHeaderHeight;

    // Use the larger of min and max to ensure we see the most rows
    const calculatedHeight = Math.max(minHeight, maxHeight);

    // Set the grid container height
    gridElement.style.height = `${calculatedHeight}px`;

    // Decide on forceFitColumns: on tablet or smaller, no; otherwise yes
    const forceFitColumns = window.innerWidth >= 768;

    const gridOptions = {
      rowHeight: rowHeight,
      forceFitColumns: forceFitColumns,
      autoHeight: false, // Disable autoHeight to use calculated height
      enableAutoResize: true
    };

    const grid = new SlickGrid(gridElement, dataView, columns, gridOptions);
    grid.render();
  }

  getItemMetadata(dataView, row) {
    const item = dataView.getItem(row);
    if (item && item.is_section) {
      return {
        columns: {
          0: { colspan: '*' },
        },
      };
    }
    return null;
  }

  htmlFormatter(row, cell, value, columnDef, dataContext) {
    if (dataContext.is_section) {
      return `<span class="font-bold py-2">${dataContext.section_label}</span>`;
    }
    return value;
  }

  async openModal(event) {
    event.preventDefault();
    event.stopPropagation();

    const { id, label, dataset, column } = event.currentTarget.dataset;
    const modal = document.getElementById("market-data-chart-modal");

    const titleElement = modal.querySelector("h3");
    if (titleElement) {
      titleElement.textContent = label;
    }

    modal.classList.remove("hidden");
    modal.setAttribute("aria-hidden", "false");

    const params = new URLSearchParams({ id, label, dataset, column });
    const frame  = document.getElementById("market-data-chart-frame");
    frame.src = `/dashboard/market_data_line?${params.toString()}`;
  }

  closeModal() {
    const modal = document.getElementById("market-data-chart-modal");
    modal.classList.add("hidden");
    modal.querySelector(":focus")?.blur();
    modal.setAttribute("aria-hidden", "true");

    const container = document.getElementById("marketDataGraphContainer");
    if (container) {
      container.innerHTML = "";
    }
  }

  selectPeriod(event) {
    const period = event.currentTarget.dataset.period;
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("period", period);
    window.location.href = currentUrl.toString();
  }
}
